import { render } from "./BaseInfiniteTable.vue?vue&type=template&id=e2a805a2&scoped=true"
import script from "./BaseInfiniteTable.vue?vue&type=script&lang=js"
export * from "./BaseInfiniteTable.vue?vue&type=script&lang=js"

import "./BaseInfiniteTable.vue?vue&type=style&index=0&id=e2a805a2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2a805a2"]])

export default __exports__